module.exports = __webpack_public_path__ + "static/media/img.headPortrait.4ce1a60f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/CompanyPublic/img/img.headPortrait.svg
// module id = 6964
// module chunks = 0